import React, { useEffect, useState } from "react";
import githubApi from "../api/modules/github";
import GlobalLoading from "../components/common/globalLoading";
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Container,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import { Link } from "react-router-dom";
import { getRandomColor } from "../utils/randomColor";
import MainContainer from "../components/common/Container";

const Projects = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const theme = useTheme();

  useEffect(() => {
    const git = async () => {
      const { response, err } = await githubApi.repos();
      response ? setIsLoading(false) : setIsLoading(true);
      setData(response);
    };
    git();
  }, []);
  console.log(isLoading);
  if (isLoading) {
    return <GlobalLoading />;
  }
  console.log(data);

  return (
    <MainContainer header="PROJECTS">
      <Stack gap="10px">
        {data.map((repo) => (
          <Card
            sx={{
              borderRadius:"0",
              position: "relative",
              paddingX: "20px",
              height: "100px",
            }}
          >
            <Box
              className="decoration"
              sx={{
                width: "10px",
                height: "100%",
                backgroundColor: theme.palette.primary.main,
                position: "absolute",
                left: 0,
              }}
            />
            <CardContent>
              <Typography component="h3" variant="" color="text.primary">
                {repo.name}
              </Typography>
            </CardContent>
            <CardActions>
              <Button
                component={Link}
                target="_blank"
                to={repo.html_url}
                size="small"
              >
                open on github
              </Button>
            </CardActions>
          </Card>
        ))}
      </Stack>
    </MainContainer>
  );
};

export default Projects;
